import { z } from 'zod';
import { toModelId } from '@/shared/types/common.types';
import { WATCH_KINDS } from '../types/watch.types';
import type { Watch } from '../types/watch.types';

/**
 * The wire contract for Conbent.Notifications' `/api/v1/watches`.
 *
 * A Python service, so the fields are snake_case, unlike Core's. Errors are FastAPI's
 * `{ "detail": ... }`: `toApiError` shows a string `detail` as is, and a 422's list of
 * field errors as its generic validation message.
 */
export const watchSchema = z.object({
  id: z.string().min(1),
  model_id: z.number().int(),
  kind: z.enum(WATCH_KINDS),
  unique_id: z.string(),
  label: z.string(),
  created_at: z.string(),
});

export const watchListSchema = z.array(watchSchema);

export function toWatch(raw: z.infer<typeof watchSchema>): Watch {
  return {
    id: raw.id,
    modelId: toModelId(raw.model_id),
    kind: raw.kind,
    uniqueId: raw.unique_id,
    label: raw.label,
    createdAt: raw.created_at,
  };
}
